import { updateUser as updateAdminUser, useAdmin, type UserAdminForm } from '@gozoki/api'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { toast } from 'sonner'
import z from 'zod/v3'
import { AdminApiKeysSection } from '~/components/routes/admins/AdminApiKeysSection'
import { CreateOrUpdateAdminForm } from '~/components/routes/admins/CreateOrUpdateAdminForm'
import type { Admin } from '@gozoki/api-types'
import { Spinner } from '~/components/ui/spinner'
import { getErrorMessageWithSentry } from '~/utils/sentry'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/users/admins/$id/edit')({
  staticData: {
    permission: ['read', 'users'],
  },
  params: {
    parse: z.object({ id: z.coerce.number() }).parse,
  },
  component: EditAdminPage,
})
withRoutePermissions(Route)

const toFormValues = (admin: Admin): UserAdminForm => ({
  firstName: admin.firstName,
  lastName: admin.lastName,
  email: admin.email,
  adminRights: admin.adminRights,
  password: null,
  storeId: admin.stores?.[0]?.id ?? null,
})

function EditAdminPage() {
  const { id } = Route.useParams()
  const navigate = useNavigate()

  const { data: admin, isLoading } = useAdmin(id)

  if (isLoading || !admin) {
    return (
      <div className="flex justify-center p-16">
        <Spinner />
      </div>
    )
  }

  return (
    <>
      <CreateOrUpdateAdminForm
        title="Modifier un administrateur"
        submitLabel="Modifier"
        hidePasswordByDefault
        defaultValues={toFormValues(admin)}
        onCancel={() => navigate({ to: '/users/bo' })}
        onSubmit={async (values) => {
          try {
            await updateAdminUser({ userId: id, ...values, storeId: values.storeId ?? undefined })
            navigate({ to: '/users/bo' })
          } catch (error) {
            toast.error(getErrorMessageWithSentry(error))
          }
        }}
      />
      <AdminApiKeysSection adminId={id} />
    </>
  )
}
